import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useToast} from "@chakra-ui/react";
import {Award, Flag, UserRoundMinus, Vote} from "lucide-react";
import {useLoggedIn, useStoreComment} from "../../store";
import useModal from "../../modals";
import useFeedback from "../../utils/use_feedback";
import {useBlock} from "../../api/user";
import pluralize from "../../utils/pluralize";
import {useSheetModal} from "../test/ModalContext";
import ReportSheet from "./report";
import AwardSheet from "./award/give_award";
import Sheet, {MenuItem, MenuItemIcon, MenuItemText} from './sheet';
import SignupPromptSheet from "./signup_prompt";

const CommentActionsSheet = styled(({className, commentId, collapsed, onMessage, onClose}) => {

    const { openModal } = useSheetModal();
    const modal = useModal();
    const loggedIn = useLoggedIn();
    const toast = useToast();
    const comment = useStoreComment(commentId);
    const {feedbackCh} = useFeedback(true);
    const block = useBlock(feedbackCh);

    const handleBlock = async () => {

        onClose();

        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {
            try {
                await block(comment.author);
                toast({
                    title: `Blocked user!`,
                    status: 'success',
                    isClosable: true,
                });
            } catch {
                toast({
                    title: `Failed to block.`,
                    status: 'error',
                    isClosable: true,
                });
            }
        }
    };

    const handleReport = () => {
        if (!loggedIn) {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><ReportSheet community={comment?.community} isPost={false} id={commentId} onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    const handleVoteBreakdown = () => {
        onClose();
        toast({
            title: `Score breakdown:`,
            description: `${pluralize(comment.score_up, 'upvote')} / ${pluralize(comment.score_down, 'downvote')}`,
            status: 'info',
            isClosable: true,
        });
    };

    const handleAward = () => {
        if (!loggedIn) {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {

            onClose();
            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><AwardSheet id={commentId} type={'post'} onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        }
    };

    return (
        <div className={className}>
            <MenuItem onClick={handleAward}>
                <MenuItemIcon>
                    <Award size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Award
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleReport}>
                <MenuItemIcon>
                    <Flag size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Report
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleBlock}>
                <MenuItemIcon>
                    <UserRoundMinus size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Block User
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={handleVoteBreakdown}>
                <MenuItemIcon>
                    <Vote size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Vote Details
                </MenuItemText>
            </MenuItem>
          </div>
    );
})``;

export default CommentActionsSheet;
